import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import Popup from '../../Popup';
import { PopupBodyWrapper } from './styles';
import ResourceSelector from '../../../containers/ResourceSelector';
import { createCombo } from '../../../containers/Editor/actions';
import { removeFileFromImport } from '../../../containers/ImportManager/actions';
import { Api } from '../../../typings/api';
import DriveItemUtils from '../../../utils/driveItem';
import { StyleColor } from '../../../utils/styles-constants';

interface CombinePanelProps {
	importManagerId: string;
	isDisplayed: boolean;
	isImporting: boolean;
	onCancel: () => void;
	dispatch: Dispatch<StoreState>;
}

const desktopFileExtensions = ['.pdf', '.epub', '.ppt', '.pptx', '.doc', '.docx', '.otp', '.odt', '.svg', '.png', '.jpg', '.jpeg', '.mov', '.mp4', '.avi', '.webm'];

const CombinePanel = ({
	importManagerId,
	isDisplayed,
	isImporting,
	onCancel,
	dispatch,
}: CombinePanelProps) => {
	const [resource, setResource] = React.useState<Api.DriveItem | null>(null);

	const handleCancelClick = () => {
		if (isImporting) {
			dispatch(removeFileFromImport(importManagerId));
		}

		onCancel();
	};

	React.useEffect(() => {
		if (resource && !isImporting) {
			dispatch(createCombo(resource));
			onCancel();
		}
	}, [resource, isImporting]);

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.combine')}
			onCancel={handleCancelClick}
			actionButtonColor={StyleColor.Blue600}
		>
			<PopupBodyWrapper>
				<ResourceSelector
					id={importManagerId}
					fileExtensions={desktopFileExtensions}
					isFileExtensionsDisplayed={false}
					isValidResourceFromApp={DriveItemUtils.isValidResourceForProposal}
					onSelect={setResource}
					actionButtonColor={StyleColor.Blue600}
				/>
			</PopupBodyWrapper>
		</Popup>
	);
};

export default CombinePanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/CombinePanel/index.tsx